import { css, useTheme } from '@fable/theme'
import { QueryKey } from 'react-query'
import {
  Logo,
  PaginationContainer,
  PaginationContainerContext,
} from '@fable/components'
import { Grid, TransitionElement } from '@fable/components'
import { useErrorModal } from '../../../../hooks'
import React, { useContext } from 'react'
import { QuoteReview } from '../../pages/review_page/ReviewPage'

export interface ProfileBaseViewProps {
  apiUrl: string
  queryArgs: QueryKey
  renderChild: (item: QuoteReview, isSingleItem?: boolean) => React.ReactNode
}

const ProfileBaseViewContent = ({
  renderChild,
}: {
  renderChild: (item: QuoteReview, isSingleItem?: boolean) => React.ReactNode
}) => {
  const { error, list, query } = useContext(PaginationContainerContext)
  const { mediaQueries } = useTheme()

  useErrorModal(error)

  if (query?.isLoading) {
    return (
      <Logo
        className={css`
          text-align: center;
        `}
        animate
        isIcon
      />
    )
  }

  return (
    <Grid
      className={css`
        width: 100%;
        padding: 0 5.46vw;
        ${mediaQueries.desktop} {
          padding: 0;
        }
      `}
      gridTemplateColumns="repeat(auto-fit, minmax(332px, 1fr))"
      gap="min(4.25vw, 20px) min(2.22vw, 32px) "
    >
      {(list || []).map((item: QuoteReview, i: number) => (
        <TransitionElement index={i} key={i} transitionType="staggerUp">
          {renderChild(item, list?.length === 1)}
        </TransitionElement>
      ))}
    </Grid>
  )
}

const ProfileBaseView = ({
  apiUrl,
  queryArgs,
  renderChild,
}: ProfileBaseViewProps) => {
  return (
    <PaginationContainer
      scrollLevel="fullPage"
      queryArgs={queryArgs}
      endpoint={apiUrl}
      limit={10}
    >
      <ProfileBaseViewContent renderChild={renderChild} />
    </PaginationContainer>
  )
}

export default ProfileBaseView
